import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from './Grid';
import { Button } from '@mui/material';
import AddressAutocomplete, { COMPONENT } from './AddressAutocomplete';
import Checkbox from './Checkbox';
import Label from './Label';
import TextField from './TextField';
import PhoneNumberList from './PhoneNumberList';
import { createForm } from '../../util/form';
import cloneDeep from 'lodash.clonedeep';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

//styles needs to be defined first
const styles = () => ({
    alignWithFloatingLabel: {
        marginTop: 17
    }
});

const CONTACT_ROLE_OPTIONS = [
    { label: 'Main contact', value: 'Main contact' },
    { label: 'AV', value: 'AV' },
    { label: 'Catering', value: 'Catering' },
    { label: 'Memorial stationery', value: 'Memorial stationery' },
    { label: 'Musician', value: 'Musician' },
    { label: 'Other', value: 'Other' }
];

const CONTACT_COMPONENT_FIELDS = {
    [COMPONENT.line1]: 'AddressLine1',
    [COMPONENT.line2]: 'AddressLine2',
    [COMPONENT.city]: 'Suburb',
    [COMPONENT.state]: 'State',
    [COMPONENT.country]: 'Country',
    [COMPONENT.code]: 'Postcode'
};

/**
 * modal dialogue used to edit the contact card info
 */
class ContactCardModal extends Component {
    static defaultProps = {
        title: 'Enter Contact Details',
        applyLabel: undefined,
        onClose: () => {}
    };

    state = {
        form: null,
        source: undefined,
        applyLabel: undefined
    };

    static getDerivedStateFromProps({ value }, state) {
        if (state.form && state.source === value) return null;

        const incoming = value || {};
        const oldContext = state.form !== null ? state.form.context : null;
        return {
            form: createForm(oldContext, cloneDeep(incoming)),
            source: value,
            applyLabel: incoming.ID ? 'Save' : 'Create'
        };
    }

    componentDidMount() {
        const { form } = this.state;
        if (form) form.context = this;
    }

    componentDidUpdate() {
        const { form } = this.state;
        if (form && form.context !== this) form.context = this;
    }

    getId() {
        return `ContactCardModal-${this.props.title}`;
    }

    onToggleRole = (role, checked) => {
        const { form } = this.state;
        const roles = form.getField('Role') || [];
        form.setField({ Role: checked ? [...roles, role] : roles.filter(item => item !== role) });
    };

    onCancel = () => {
        this.props.onClose();
    };

    onSubmit = () => e => {
        e.preventDefault();

        const { onSubmit } = this.props;
        const { form } = this.state;

        if (!onSubmit || !form) return;

        onSubmit({
            ID: form.getField('ID'),
            Name: form.getField('Name'),
            Role: form.getField('Role'),
            Phones: form.getField('Phones'),
            Email: form.getField('Email'),
            AddressLine1: form.getField('AddressLine1'),
            AddressLine2: form.getField('AddressLine2'),
            Suburb: form.getField('Suburb'),
            State: form.getField('State'),
            Postcode: form.getField('Postcode'),
            Country: form.getField('Country')
        });

        this.onCompleted();
    };

    onCompleted = contact => {
        const { onClose } = this.props;
        if (onClose) onClose(contact);
        const clearedState = Object.keys(this.state).reduce((acc, key) => {
            acc[key] = '';
            return acc;
        }, {});
        this.setState(clearedState);
    };

    render() {
        return (
            <Dialog open={this.props.open} onClose={this.onClose} aria-labelledby={this.getId()}>
                {this.renderForm()}
            </Dialog>
        );
    }

    renderForm() {
        const { title } = this.props;
        const { applyLabel, form } = this.state;
        if (!form) return null;
        return (
            <form onSubmit={this.onSubmit()}>
                <DialogTitle id={this.getId()}>{title}</DialogTitle>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            {this.renderTextField('Name', 'Name', true, true)}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <Label text="Role" />
                        </Grid>
                        {CONTACT_ROLE_OPTIONS.map(option => (
                            <Grid item xs={6} key={option.value}>
                                <Checkbox
                                    name={`Role-${option.value}`}
                                    label={option.label}
                                    checked={(form.getField('Role') || []).includes(option.value)}
                                    onChange={(e, checked) => this.onToggleRole(option.value, checked)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            {this.renderAddressField('Address', 'Address', 'Search for an address')}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PhoneNumberList name="Phones" label="Phone" form={form} />
                        </Grid>
                        <Grid item xs={12}>
                            {this.renderTextField('Email', 'Email')}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onCancel} color="primary">
                        Cancel
                    </Button>
                    <Button type="submit" color="primary">
                        {applyLabel}
                    </Button>
                </DialogActions>
            </form>
        );
    }

    renderTextField(name, label, autoFocus, required) {
        const { form } = this.state;
        return (
            <TextField
                label={label}
                name={name}
                autoFocus={autoFocus}
                margin="dense"
                required={required}
                form={form}
            />
        );
    }

    renderAddressField(name, label, placeholder) {
        const { classes } = this.props;
        const { form } = this.state;
        return (
            <div className={classes.alignWithFloatingLabel}>
                <AddressAutocomplete
                    label={label}
                    name={name}
                    margin="dense"
                    placeholder={placeholder}
                    componentFields={CONTACT_COMPONENT_FIELDS}
                    form={form}
                />
            </div>
        );
    }
}

export default withStyles(styles)(ContactCardModal);
